import { useParams } from 'react-router-dom';
import Slider from "react-slick";
import { SlickArrowLeft, SlickArrowRight, SlickProps } from '../../../lib/Slick';
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { HomeNoticeItem } from './HomeNoticeItem';

export const HomeNotice = () => {
    const { school } = useParams();
    
    const {data:homeList, isFetching, isError} = useQuery({
        queryKey:['/home/notice'],
        queryFn:()=>Api.post('/api/notice/popup', {school}),
        staleTime:3*60*1000,
        placeholderData:keepPreviousData
    });
    
    if (isFetching || isError ||
        homeList.data?.length <= 0)
            return <div className="notice"></div>;


    return (
        <div className="notice">
            <h2 className="notice_top">
                알림판
            </h2>
            <Slider className="notice_board slider_wrap" {...SlickProps}
                slidesToShow={1} slidesToScroll={1} dots={false}
                autoplay={true}
                autoplaySpeed={5000}
                prevArrow={<SlickArrowLeft cn="prev_btn _yellow" />}
                nextArrow={<SlickArrowRight cn="next_btn _yellow" />}
                responsive={[{ settings: { slidesToShow: 1, slidesToScroll: 1 } }]}
            // afterChange={onAfterChange}
            >
                {homeList.data?.map(notice => <HomeNoticeItem notice={notice} key={notice.id} />)}
            </Slider>
        </div>
    )
}

